import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../components_web/Header";
import Footer from "../components_web/Footer";
import SideMenu from "../components_web/SideMenu";
import { ProfileService } from "../src/api";
import { getClass } from "../src/helpers/formatHelpers";

const Contact = () => {
  const { t } = useTranslation();
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [email, setEmail] = useState("");
  const [statusNewsletter, setStatusNewsletter] = useState(null);

  const actionSubscribe = () => {
    ProfileService.subscribeNewsletter({ email })
      .then((res) => {
        setStatusNewsletter(res.data.message);
        setEmail("");
      })
      .catch((err) => {
        setStatusNewsletter(err?.data?.message);
        setEmail("");
      });
  };

  return (
    <div>
      <NextSeo
        title={`Contact - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/contact`}
        additionalMetaTags={{
          name: "keywords",
          content:
            "contact, festival, event, artist, music, live music, concert, ticket",
        }}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/contact`,
          title: `Contact - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      {/* Contact Section */}
      <div className={`${getClass("background", true)}`} id="contact">
        <div className="wrapper mx-auto relative px-10 min-h-screen py-60 flex justify-center items-center">
          <div className="max-w-1160px flex-1 mx-auto">
            <div className="flex flex-col items-center">
              <h1
                className={`sm:text-3xl text-lg font-bold ${getClass(
                  "text-white",
                  true
                )} text-center sm:mb-14 mb-6`}>
                {t("key_web_home_contact_title")}
              </h1>
              <div className="grid md:grid-cols-3 grid-cols-1 sm:gap-10 gap-5">
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_1_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_1_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center`}>
                    info@supervybe.com
                  </div>
                </div>
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_2_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_2_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center`}>
                    press@supervybe.com
                  </div>
                </div>
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_3_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_3_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center`}>
                    business@supervybe.com
                  </div>
                </div>
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_4_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_4_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center`}>
                    ad@supervybe.com
                  </div>
                </div>
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_5_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_5_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center`}>
                    report@supervybe.com
                  </div>
                </div>
                <div className="px-0">
                  <div
                    className={`sm:text-xl text-lg font-bold ${getClass(
                      "text-white",
                      true
                    )} text-center mb-2`}>
                    {t("key_web_home_contact_item_6_title")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    {t("key_web_home_contact_item_6_subtitle")}
                  </div>
                  <div
                    className={`sm:text-lg text-sm font-regular text-center ${getClass(
                      "text-white80",
                      true
                    )} mb-2`}>
                    <Link
                      prefetch={false}
                      href={`/${process.env.NEXT_PUBLIC_APP_NAME?.replace(
                        " ",
                        ""
                      )?.toLowerCase()}-pro/`}>
                      <a
                        title={t("key_web_here")}
                        className={`${getClass(
                          "text-white",
                          true
                        )} font-bold underline`}>
                        {t("key_web_here")}
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      {/* <div className="bg-grayBackground mx-auto">
        <div className="flex md:flex-row flex-col-reverse">
          <div className="flex-1">
            <iframe
              loading="lazy"
              title="Google Map"
              width="100%"
              height="100%"
              style={{ filter: "invert(90%)" }}
              src="https://maps.google.com/maps?q=Shelton St, London WC2H 9JQ, UK&amp;t=&amp;z=9&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
            />
          </div>
          <div className="flex flex-col flex-1 justify-center items-center py-7%">
            <div className="flex flex-row items-center mb-8">
              <img src="/images/location-icon.svg" width="25" alt="location" />
              <div className="sm:text-3xl text-lg font-bold text-white text-center ml-2">
                {t("key_web_office")}
              </div>
            </div>
            <div className="sm:text-xl text-base font-regular text-white80 text-center sm:mb-4 mb-2">
              71-75 Shelton Street, WC2H 9JQ
            </div>
            <div className="sm:text-xl text-base font-regular text-white80 text-center sm:mb-4 mb-2">
              London, Greater London
            </div>
            <div className="sm:text-xl text-base font-regular text-white80 text-center sm:mb-4 mb-2">
              United Kingdom
            </div>
          </div>
        </div>
      </div> */}

      {/* Newslestter Section */}
      {/* <div className="bg-black5">
        <div
          className="wrapper mx-auto relative md:py-7% py-20"
          style={{ paddingLeft: 20, paddingRight: 20 }}>
          <div className="flex flex-col items-center">
            <div className="sm:text-3xl text-lg font-bold text-white text-center sm:mb-8 mb-4">
              {t("key_web_home_newsletter_title")}
            </div>
            <div className="sm:text-xl text-lg font-regular text-white text-center sm:mb-8 mb-4">
              {t("key_web_home_newsletter_subtitle")}
            </div>
            <div className="bg-white rounded-full flex flex-row items-center justify-center md:pl-8 pl-4 md:h-12 h-10 md:w-700px w-full">
              <input
                className="bg-white font-regular md:text-base text-sm text-black outline-0 w-full"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div
                className="bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 md:py-4 py-3 md:pl-11 pl-6 md:pr-10 pr-6 rounded-full text-xs font-bold text-white uppercase cursor-pointer"
                onClick={() => actionSubscribe()}>
                Subscribe
              </div>
            </div>
          </div>
          {statusNewsletter && (
            <div className="text-base font-bold text-white text-center mt-6">
              {statusNewsletter === "success"
                ? "Thank you for subscribing to our Newsletter"
                : statusNewsletter === "duplicate_parameter"
                ? "Your email already subscribed to our Newsletter"
                : "Something wrong with our system"}
            </div>
          )}
        </div>
      </div> */}

      <Footer />
    </div>
  );
};

export default Contact;
